import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/AppraisalQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class AppraisalQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "AppraisalQueryStore",
			variables: true,
		})
	}
}

export async function load_AppraisalQuery(params) {
  await initClient()

	const store = new AppraisalQueryStore()

	await store.fetch(params)

	return {
		AppraisalQuery: store,
	}
}
